<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="flex flex-col h-full w-full p-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <span>Virtual Career Fair</span>
                    </div>
                    <div class="font-bold">Virtual Career Fair</div>
                </div>

                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between flex-wrap gap-4">
                        <h1 class="text-base md:text-lg font-semibold">Virtual Career Fair List</h1>
                    </div>
                    <div class="flex flex-col" v-if="$apollo.queries.event_employers.loading">
                        <table-shimmer :titleHeaders="[
                            '#',
                            'Title',
                            'Description',
                            'Entity',
                            'No.of Registrations',
                            'View Registrations',
                        ]" :rows="first"></table-shimmer>
                    </div>
                    <div v-else-if="!$apollo.queries.event_employers.loading && !hasItems"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No virtual career fair found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">
                                                    #
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Title
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Description
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    Entity
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    No.of Registrations
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    View Registrations
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">
                                                    {{ paginatorInfo.firstItem + index }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <span @click.stop="goToEvent(item.event.slug)"
                                                        class="font-medium hover:text-blue-600 hover:underline cursor-pointer">{{
                                                            item.event.title
                                                        }}</span>
                                                </td>
                                                <td class="px-6 py-2">
                                                    <div class="truncate-3">{{ item.event.description }}</div>
                                                </td>
                                                <td class="px-6 py-2">
                                                    {{ getEntityName(item.event.entity.entity) }}
                                                </td>
                                                <td class="px-6 py-2 text-center">
                                                    {{ item.attachments_count }}
                                                </td>
                                                <td class="px-6 py-2">
                                                    <div class="flex justify-center">
                                                        <div v-if="item.attachments_count"
                                                            @click.stop="viewRegistrations(item.token, item.event.title)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer">
                                                            <icon-document-list
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-document-list>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import gql from "graphql-tag";
import Pagination from "../../components/shared/pagination.vue";
import TableShimmer from "../../components/shared/TableShimmer.vue";
import IconDocumentList from "../../components/icons/IconDocumentList.vue";
export default {
    name: "virtual-career-fair",
    components: {
        Pagination,
        TableShimmer,
        IconDocumentList,
    },
    data() {
        return {
            event_employers: [],
            first: 10,
            page: 1,
        };
    },
    computed: {
        partnerId() {
            return this.$store.getters.partner_id;
        },
        items() {
            return this.event_employers.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.event_employers.paginatorInfo;
        },
    },
    apollo: {
        event_employers() {
            return {
                query: gql`
                    query GetAllEventEmployers(
                        $first: Int!
                        $page: Int!
                        $partner_id: Int
                    ) {
                        event_employers(
                        first: $first
                        page: $page
                        partner_id: $partner_id
                    ) {
                        error
                        error_code
                        message
                        data {
                            token
                            event {
                                title
                                slug
                                description
                                entity {
                                    entity
                                }
                            }
                            attachments_count
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        partner_id: parseInt(this.partnerId),
                    };
                },
                fetchPolicy: "cache-and-network",
            };
        },
    },
    methods: {
        setPage(page) {
            this.page = page;
        },
        goToEvent(slug) {
            const url = `#/events/${slug}`;
            window.open(url, "_blank");
        },
        getEntityName(entity) {
            return entity.replace(/ATHS/g, "ATS");
        },
        viewRegistrations(token, title) {
            localStorage.setItem("virtualCareerFairRegistrationTitle", title);
            this.$router.replace(`/virtual-career-fair/registrations/${token}`);
        },
    },
}
</script>

<style lang="scss" scoped>
.truncate-3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
</style>